import React, { useEffect, useMemo, useState } from "react";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import MUIDataTable from "mui-datatables";
import { MySnackbar } from "../../components/mySnackbar/MySnackbar";
import textLabels from "../../components/dataTable/textLabel";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import rest from '../../rest';
import TableGroupe from "./tableGroupe";
import MenuGestionGroupe from "./menuGestioGroupe";


const GestionDeGroupe = () => {

    const [loading, setLoading] = useState(false);
    const [snack, setSnack] = useState({});
    const [groupeData, setGroupeData] = useState([]);

    useEffect(() => {
        setLoading(true);
        let param = {};
        rest.post('/gestionDeGroupe/getGroupeList.json', JSON.stringify(param))
            .then(function (response) {
                setGroupeData(response.data);
                setLoading(false);
                setSnack({ message: 'groupe send', show: true, severity: "success" });
            })
            .catch(function (error) {
                console.log(error);
                setSnack({ message: error, show: true, severity: "error" });
                setLoading(false);
            });
    }, []);


    const tab = useMemo(() => {
        return groupeData;
    }, [groupeData])

    const columns = [
        {
            name: "Nom",
            label: "Groupe",
            options: {
                customBodyRender: (value, row) => {
                    const groupePerson = row.rowData[5];
                    let nom = "";
                    let mail = "";
                    let phone = "";

                    if (groupePerson) {
                        nom = groupePerson.Name || "";
                        mail = groupePerson.Email || "";
                        phone = groupePerson.Phone_Mobile || "";
                    }

                    return (
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div className="containerGrouptTitre">
                                    <Typography className={'test'}>{value}</Typography>
                                    <Typography className={'test'}>{nom} {mail} {phone}</Typography>
                                    <MenuGestionGroupe
                                        onClick={(event) => event.stopPropagation()}
                                        onFocus={(event) => event.stopPropagation()}/>
                                </div>


                            </AccordionSummary>
                            <AccordionDetails>
                                <TableGroupe rowData={row.rowData[4]}></TableGroupe>
                            </AccordionDetails>
                        </Accordion>
                    );
                }
            },
        },
        {
            name: "ID",
            label: "ID",
            options: {
                display: false,
            },
        },
        {
            name: "Retrait",
            label: "Retrait",
            options: {
                display: false,
            },
        },
        {
            name: "Type",
            label: "Type",
            options: {
                display: false,
            },
        },
        {
            name: "groupe_membreGroupe",
            label: "groupe_membreGroupe",
            options: {
                display: false,
            },
        },
        {
            name: "groupe_person",
            label: "groupe_person",
            options: {
                display: false,
            },
        },
    ]

    const options = {
        search: true,  // Désactive l'icône de recherche
        filter: false,  // Désactive l'icône de filtre
        download: false,  // Désactive l'icône de téléchargement/export
        print: false,  // Désactive l'icône d'impression
        viewColumns: false,  // Désactive l'icône de vue des colonnes
        selectableRowsHeader: false,  // Désactive la case à cocher de sélection globale
        selectableRowsHideCheckboxes: true,  // Cache les cases à cocher de sélection individuelles
        selectableRows: 'none',
        sort: false,
        textLabels: textLabels,
        customToolbar: () => {
            return (
                <div>
                    <div style={{ textAlign: 'left', paddingBottom: '10px', paddingLeft: '25px', position: 'absolute', width: '100%', left: '0' }}>
                        <p>{`Veuillez sélectionner les profils à fusionner. Les profils sélectionnés apparaitront en bas de page.`}</p>
                    </div>
                </div>
            );
        },
    };

    return (
        <div>
            <LoadingIndicator open={loading} />
            <MySnackbar params={snack} />
            <MUIDataTable
                key={1}
                title={"Gestion de groupe"}
                data={tab}
                columns={columns}
                options={options}
                className='DataTableProperTips'
            />
        </div>
    );
};


export default GestionDeGroupe;